module.exports = __webpack_public_path__ + "static/media/laboulangere-square.d147c4fc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/laboulangere-square.png
// module id = 1809
// module chunks = 0